export function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export function timestampToReadable(t) {
  return new Date(t * 1000).toLocaleString()
}

export function decimalToHex(d, padding) {
  var hex = Number(Math.round(d)).toString(16)
  
  padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding

  while (hex.length < padding) {
    hex = "0" + hex
  }

  return hex
}

export function arraySetsEqual(a, b) {
  let allIn = (a, b) => {
    let result = true
    a.forEach((e) => {
      if (b.indexOf(e) < 0) {
        result = false
      }
    })
    return result
  }

  return allIn(a, b) && allIn(b, a)
}
